<template>
  <a-layout id="hm-web">
    <Header class="show-pc"/>
    <HeaderH5 class="show-h5" />
    <a-layout-content class="hm-web-content">
      <div class="hm-web-content__main">
        <router-view />
      </div>
    </a-layout-content>
    <Footer />
    <popover class="pop-over"></popover>
  </a-layout>
</template>

<script>
import Header from './header/index.vue'
import HeaderH5 from './header/index_h5.vue'
import Footer from './footer/index.vue'
import Popover from '@/components/popover'

export default {
  name: 'hm-web-pageView',
  components: {
    Header,
    HeaderH5,
    Footer,
    Popover
  },
  data () {
    return {}
  }
}
</script>

<style lang="less">
#hm-web {
  // width: calc(100vw - 5px); // 5px的滚动条
  width: 100vw;
  overflow-x: hidden;
  .hm-web-content {
    margin-top: 88PX;
    &__main {
      width: 100%;
      // margin-top: -98px;
    }
  }
}
@media screen and (max-width: 1200px) {
  #hm-web {
    .hm-web-content {
      margin-top: 98px;
    }
    .pop-over{
      z-index: 99999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pageView.vue